const SUCURSALES_UNSUPPORTED_KEY = 'aionbi:sucursales-unsupported';

export const isSucursalesSupported = () =>
  typeof sessionStorage !== 'undefined' && sessionStorage.getItem(SUCURSALES_UNSUPPORTED_KEY) !== 'true';

export const markSucursalesUnsupported = () => {
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.setItem(SUCURSALES_UNSUPPORTED_KEY, 'true');
  }
};

export default {} as const;
